
import Vue, { PropType } from "vue";
import { Bar, Doughnut, HorizontalBar, Line } from "vue-chartjs";

import _ from "lodash";

export default Vue.extend({
    extends: Doughnut,
    data() {
        return {
            options: {
                responsive: true,
                maintainAspectRatio: false,
            },
        };
    },
    props: {
        datasets: Array,
        labels: Array,
    },
    computed: {
        chartdata() {
            return {
                labels: this.labels,
                datasets: this.datasets,
            };
        },
    },
    mounted() {
        this.renderChart(this.chartdata, this.options);
    },
});
